import { render, staticRenderFns } from "./DetaiInfoPage.vue?vue&type=template&id=63816c54&scoped=true&"
import script from "./DetaiInfoPage.vue?vue&type=script&lang=js&"
export * from "./DetaiInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./DetaiInfoPage.vue?vue&type=style&index=0&id=63816c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63816c54",
  null
  
)

export default component.exports